<template>
    <div>
      <FormSlot
        :stage="stage"
        :product="product"
        :urlAvailability="urlAvailability"
        @slotChange="onSlotChange"
        @findEquipment="onFindEquipment"
      >
      </FormSlot>
      <div class="form-group mt-5">
        <button class="btn btn-primary btn-block btn-lg d-flex align-items-center justify-content-center"
                v-on:click.prevent="onClickConfirmBooking()"
                :disabled="!slot || !equipment">
          <span>
              {{ $t('Book now') }}
          </span>
        </button>
      </div>
    </div>
</template>

<script>
import FormSlot from "@/components/frontend/booking/slot/Form.vue";
export default {
  name: "ProductStageAvailability",
  components: {
    FormSlot,
  },
  props: {
    product: {
      required: true,
    },
    stage: {
      required: true,
    },
    urlAvailability: {
      required: true,
    },
  },
  data() {
    return {
      equipment : null,
      slot: null,
    }
  },
  methods: {
    onSlotChange(slot) {
      this.slot = slot;
    },
    onFindEquipment(equipment) {
      this.equipment = equipment;
    },
    onClickConfirmBooking() {
      this.$emit('submitBooking', {
        slot: this.slot,
        equipment: this.equipment,
      });
    }
  },
}
</script>

<style scoped>

</style>